export default {
	name: "eiis-router",
  props: {
    items: Array
  },
  data() {
    return {
      view: "index.js"
    }
  },
  computed: {
    computedClasses: function () {
      let c = (this.placement == 'default' ? '' : this.placement);
      // TODO c += (this.alignment == 'center' ? 'centered mx-auto' : this.alignment);
      return c;
    }
  },
  methods: {
    navigate(name) {
      console.log("navigate to", name);
      this.view = () => import(`/${name}View.js`);
      console.log(this.view);
    }
  },
  template: `
    <div class="eiis-menu"
        v-bind:class=computedClasses
    >
      <div id="menu-header">{{header}}</div>
      <div><component :is="view">her</component></div>
      <div class="menu-items">
        <nav class="nav flex-column">
          <div class="nav-item active" v-for="item in items">

          <slot name="item" v-bind:item="item"></slot>

          <a class="nav-link active" v-bind:href=item.URL v-if=!item.IsDropdown @click.prevent="navigate">
            <i v-bind:class=item.Icon v-if=item.Icon></i>
            {{item.Text}}<span class="sr-only">(current)</span>
            <div class="nav-item dropdown" v-if=item.IsDropdown>
              <a class="nav-link active v-bind:href=item.URL dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{item.Text}}
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <div v-for="subitem in item.Items">
                  <a class="dropdown-item" v-bind:href=subitem.URL @click.prevent="navigate">
                    {{subitem.Text}}
                  </a>
                  <div class="dropdown-divider" v-if=subitem.IsDivider></div>
                </div>
              </div>
            </div>
          </a>
          </div>
        </nav>
      </div>
    </div>	
  `
}